import Vue from 'vue'
import BlobSwiperSlide from './BlobSwiperSlide'

Vue.component('blob-swiper-slide', BlobSwiperSlide)
